// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ziSy","infoBtn":"quickbooks_infoBtn__2v5uS","formBox":"quickbooks_formBox__2ecWr","formFooter":"quickbooks_formFooter__1kS-u"};